/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Wechat_Serial_NoInputs */

const en_admin_settings_fields_wechat_serial_no = /** @type {(inputs: Admin_Settings_Fields_Wechat_Serial_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certificate Serial No`)
};

/**
* | output |
* | --- |
* | "Certificate Serial No" |
*
* @param {Admin_Settings_Fields_Wechat_Serial_NoInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_wechat_serial_no = /** @type {((inputs?: Admin_Settings_Fields_Wechat_Serial_NoInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Wechat_Serial_NoInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_wechat_serial_no(inputs)
});
export { admin_settings_fields_wechat_serial_no as "admin.settings.fields.wechat_serial_no" }